import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImageProps } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import { accentColors, colorMap } from '../../utils';

import smLogo from '../../assets/logo-bus-sm.svg';

export interface ICtaInlineProps extends IBaseElementProps {
	backgroundColor?: accentColors;
	heading?: string;
	button?: ILink;
	/**
	 * Default image is the My Big Yellow Bus logo
	 */
	image?: IImageProps;
	disableTopMargin?: boolean;
}

/**
 * Small Call To Action Banner
 * @icon interactive
 * @block
 */

const CtaInline: React.FC<ICtaInlineProps> = ({
	heading,
	button,
	image,
	backgroundColor = 'green',
	disableTopMargin = false,
}) => {
	const defaultImg = {
		src: smLogo,
		alt: 'My Big Yellow Bus',
		width: 140,
		height: 70,
	};

	const img = image || defaultImg;

	return (
		<div
			className={cn(
				'inline-cta-bar',
				`inline-cta-bar--bg-${colorMap[backgroundColor]}`,
				{
					'mt-0': disableTopMargin,
				},
			)}
		>
			<div className="inline-cta-bar__wrapper container">
				<div className="inline-cta-bar__image">
					<Image {...img} />
				</div>
				<div className="inline-cta-bar__content-wrapper row justify-content-center justify-content-md-between">
					<h3 className="inline-cta-bar__content col-12 col-md text-center text-md-start">
						{heading}
					</h3>
					<div className="inline-cta-bar__button-wrapper col-auto">
						<Button {...button} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default CtaInline;
